module.exports = __webpack_public_path__ + "static/media/3.19_preview.2b2a7910.png";